module.exports = __WEBPACK_EXTERNAL_MODULE_51__;


//////////////////
// WEBPACK FOOTER
// external {"root":["dateFns","getDate"],"commonjs":"date-fns/get_date/index","commonjs2":"date-fns/get_date/index"}
// module id = 51
// module chunks = 0